import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Col, Row } from 'reactstrap'
import { withTranslation } from 'react-i18next';

// Import SVG files
import mastercardSvg from '../img/payment_methods/card_mastercard.svg';
import visaSvg from '../img/payment_methods/card_visa.svg';
import postfinanceSvg from '../img/payment_methods/card_post-finance-pay.svg';
import twintSvg from '../img/payment_methods/card_twint.svg';
import paypalSvg from '../img/payment_methods/card_paypal.svg';
import applePaySvg from '../img/payment_methods/card_apple-pay.svg';
import googlePaySvg from '../img/payment_methods/card_google-pay.svg';
import samsungPaySvg from '../img/payment_methods/card_samsung-pay.svg';
import amexSvg from '../img/payment_methods/card_american-express.svg';
import dinersSvg from '../img/payment_methods/card_diners-club.svg';
import klarnaSvg from '../img/payment_methods/card_klarna.svg';

class Footer extends Component {
    shouldShowOldHours() {
        const switchDate = new Date('2025-06-01T00:00:00+02:00'); // Swiss time
        return new Date() < switchDate;
    }

    render() {
        const { t } = this.props;
        return (
            <footer className="main-footer" style={{paddingBottom: '80px'}}>
                <div className="main-block">
                    <div className="container pt-3 pb-3">
                        <Row className="justify-content-md-center">
                            <Col sm="4">
                                <Row className="align-items-center">
                                    <Col md="auto">
                                        <img style={{ height: '120px', width: '120px' }}
                                            src={require("../img/logo_white.png")}
                                            alt={t('footer.logoAlt')}
                                        />
                                    </Col>
                                    <Col className="align-self-center" md="auto" style={{ fontSize: "15px", color: "white" }}>
                                        <Row><Col>Hohlstrasse 192</Col></Row>
                                        <Row><Col>8004 Zürich</Col></Row>
                                        <Row><Col>
                                            <div className="d-flex align-items-center">
                                            <div style={{'width': '20px'}}>Tel: </div> 
                                            <a className="text-white ml-1" href="tel:0443042298">
                                                044 304 22 98
                                                </a>
                                            </div>
                                            </Col></Row>
                                        <Row><Col>
                                            <a className="d-flex align-items-center text-white" href="//wa.me/+41795964895">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="white" d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg>
                                                <div className="ml-1">079 596 48 95</div>
                                            </a>
                                        </Col></Row>
                                        <Row><Col><a className="text-white" href="mailto:info@woes.ch">info@woes.ch</a></Col></Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col className="align-self-center" sm="2" style={{ fontSize: "15px", color: "white" }}>
                                <Row>
                                    <Link to="/agb" style={{ color: "white" }}>{t('footer.links.terms')}</Link>
                                </Row>
                                <Row>
                                    <Link to="/privacy" style={{ color: "white" }}>{t('footer.links.privacy')}</Link>
                                </Row>
                                <Row>
                                    <Link to="/imprint" style={{ color: "white" }}>{t('footer.links.imprint')}</Link>
                                </Row>
                                <Row className="Link2">
                                    <Link to={this.props.i18n.language === 'en' ? '/en/faq' : '/faq'} style={{ color: "white" }}>{t('footer.links.faq')}</Link>
                                </Row>
                            </Col>
                            <Col className="align-self-center" sm="4" style={{ fontSize: "15px", color: "white" }}>
                                <Row><Col>{t(this.shouldShowOldHours() ? 'footer.hoursold.title' : 'footer.hours.title')}</Col></Row>
                                <Row>
                                    <Col>{t(this.shouldShowOldHours() ? 'footer.hoursold.weekdays' : 'footer.hours.weekdays')}</Col>
                                    <Col>{t(this.shouldShowOldHours() ? 'footer.hoursold.weekdayHours' : 'footer.hours.weekdayHours')}</Col>
                                </Row>
                                {this.shouldShowOldHours() && (
                                    <Row>
                                        <Col>{t('footer.hoursold.saturday')}</Col>
                                        <Col>{t('footer.hoursold.saturdayHours')}</Col>
                                    </Row>
                                )}
                                <Row>
                                    <Col>{t(this.shouldShowOldHours() ? 'footer.hoursold.online' : 'footer.hours.online')}</Col>
                                    <Col>{t(this.shouldShowOldHours() ? 'footer.hoursold.onlineHours' : 'footer.hours.onlineHours')}</Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="justify-content-md-center" style={{ marginTop: "40px" }}>
                            <div style={{ 
                                display: 'flex', 
                                flexWrap: 'wrap', 
                                gap: '15px', 
                                justifyContent: 'center',
                                maxWidth: '500px',
                                margin: '0 auto'
                            }}>
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={twintSvg}
                                    alt={t('footer.payments.twint')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={mastercardSvg}
                                    alt={t('footer.payments.mastercard')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={visaSvg}
                                    alt={t('footer.payments.visa')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={postfinanceSvg}
                                    alt={t('footer.payments.postfinance')}
                                    loading="lazy"
                                />
                                
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={paypalSvg}
                                    alt={t('footer.payments.paypal')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={klarnaSvg}
                                    alt={t('footer.payments.klarna')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={applePaySvg}
                                    alt={t('footer.payments.applePay')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={googlePaySvg}
                                    alt={t('footer.payments.googlePay')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={samsungPaySvg}
                                    alt={t('footer.payments.samsungPay')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={amexSvg}
                                    alt={t('footer.payments.amex')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={dinersSvg}
                                    alt={t('footer.payments.diners')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={require("../img/payment_methods/gift_card.png")}
                                    alt={t('footer.payments.giftCard')}
                                    loading="lazy"
                                />
                            </div>
                        </Row>
                    </div>
                </div>
            </footer>
        );
    }
}

export default withTranslation()(Footer);